"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useState } from "react";
import ReactCountUp from "react-countup";
import { useFilterSearch } from "../hooks/use-filter-search";
import { useLocale } from "../hooks/use-locale";
import { cn } from "../utils/cn";
export function CountUp(t0) {
  const $ = _c(24);
  const {
    children,
    className,
    initialCount
  } = t0;
  const locale = useLocale();
  const results = useFilterSearch();
  const totalHits = results.data?.pages[0]?.totalHits ?? initialCount ?? 0;
  let t1;
  if ($[0] !== locale) {
    t1 = 1000 .toLocaleString(locale).slice(1, 2);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const separator = t1;
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== locale || $[5] !== totalHits) {
    t4 = totalHits.toLocaleString(locale);
    $[4] = locale;
    $[5] = totalHits;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const display = t4;
  let t5;
  if ($[7] !== className) {
    t5 = cn(className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== display) {
    t6 = <span aria-hidden={true} className="invisible col-start-1 row-start-1" suppressHydrationWarning={true}>{display}</span>;
    $[9] = display;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== mounted || $[12] !== separator || $[13] !== totalHits) {
    t7 = mounted ? <ReactCountUp duration={1.5} end={totalHits} preserveValue={true} separator={separator} start={0} /> : "0";
    $[11] = mounted;
    $[12] = separator;
    $[13] = totalHits;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <span className="col-start-1 row-start-1">{t7}</span>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <span className="inline-grid whitespace-nowrap">{t6}{t8}</span>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== children || $[21] !== t5 || $[22] !== t9) {
    t10 = <span className={t5}>{t9}{children}</span>;
    $[20] = children;
    $[21] = t5;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}